import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
    };
};

export const getCustomerSegregationReport = async (businessId, branchId) => {
    try {
        const response = await axios.get(`${BASE_URL}/api/CustomerSegregationReport`, {
            params: { businessId, branchId },
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching customer segregation report:", error);
        throw error;
    }
};

// Export to Excel
export const exportCustomerSegregationReportToExcel = async (businessId, branchId) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/CustomerSegregationReport/export-excel`,
            { business_Id: businessId, branch_Id: branchId },
            {
                headers: getAuthHeader(),
                responseType: 'blob'
            }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `CustomerSegregationReport_${new Date().getTime()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        return true;
    } catch (error) {
        console.error("Error exporting customer segregation report:", error);
        throw error;
    }
};
